(() => {
  const content = document.querySelector('.cp-article-body');
  const graph = document.querySelector('script[data-campus-schema="site"]');
  if (!content || !graph) return;

  let article;
  try {
    article = JSON.parse(graph.textContent)['@graph'].find((node) => node['@type'] === 'BlogPosting');
  } catch {
    return;
  }
  if (!article) return;

  const elements = [...content.children];
  const clean = (element) => element.textContent.replace(/\s+/g, ' ').trim();
  const label = (element) => clean(element).replace(/:$/, '').toLowerCase();
  const ingredients = elements.map((element, index) => /^(ingredients?|what you need)$/.test(label(element)) ? index : -1).filter((index) => index >= 0);
  const directions = elements.map((element, index) => /^(directions?|instructions?|preparation instructions?)$/.test(label(element)) ? index : -1).filter((index) => index >= 0);
  if (ingredients.length !== 1 || directions.length !== 1 || directions[0] <= ingredients[0]) return;

  const ingredientItems = elements.slice(ingredients[0] + 1, directions[0])
    .flatMap((element) => [...element.querySelectorAll('li')])
    .map(clean).filter(Boolean);
  if (ingredientItems.length < 2) return;

  const steps = [];
  for (const element of elements.slice(directions[0] + 1)) {
    if (element.matches('h1, h2, h3, h4, h5, h6')) break;
    if (/^(macros?|nutrition|recipe by|calories)\b/i.test(clean(element))) break;
    if (element.matches('ol, ul')) {
      steps.push(...[...element.querySelectorAll('li')].map(clean).filter(Boolean));
    } else if (element.matches('p') && !element.querySelector('img')) {
      const text = clean(element);
      if (text) steps.push(text);
    }
  }
  if (!steps.length) return;

  const recipe = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    '@id': `${article.url}#recipe`,
    url: article.url,
    name: article.headline,
    mainEntityOfPage: article.mainEntityOfPage,
    recipeIngredient: ingredientItems,
    recipeInstructions: steps.map((text) => ({ '@type': 'HowToStep', text }))
  };
  if (article.image) recipe.image = article.image;
  if (article.author) recipe.author = article.author;
  if (article.datePublished) recipe.datePublished = article.datePublished;
  if (article.dateModified) recipe.dateModified = article.dateModified;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.dataset.campusSchema = 'recipe';
  script.textContent = JSON.stringify(recipe);
  document.head.appendChild(script);
})();
